import React from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { CollectionCard } from "@/components/product/CollectionCard";
import { Reveal } from "@/components/common/Reveal";
import { useCollections } from "@/hooks/useCatalog";

export function FeaturedCollections() {
  const { data } = useCollections();
  const featured = (data?.collections || []).filter((c) => c.featured).slice(0, 4);

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeading
        eyebrow="Curated For You"
        title="Shop by Collection"
        subtitle="Explore our signature categories, each hand-selected for its craftsmanship and timeless appeal."
      />
      <div className="mt-12 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4">
        {featured.map((c, i) => (
          <Reveal key={c.handle} delay={i * 0.08}>
            <CollectionCard collection={c} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
